import { IonDatetime, IonDatetimeButton, IonItem, IonLabel, IonPopover } from '@ionic/react';
import { DateTime } from 'luxon';
import { RoundedSquareIcon } from './Icon';
import { faCalendar } from '@fortawesome/pro-regular-svg-icons';

const DatePicker: React.FC<{
    defaultDate: DateTime | null;
    id: string;
    title: string;
    color?: string;
    disabled?: boolean;
    className: string;
    onChange?: (value: DateTime) => void;
}> = ({ defaultDate, id, title, disabled, color, className, onChange }) => {
    return (
        <IonItem lines="full" style={{ '--background': 'white' }} className={className} disabled={disabled}>
            <RoundedSquareIcon icon={faCalendar} color={color} />
            <IonLabel className={`pl-1 ${disabled ? 'item-interactive-disabled' : ''}`}>{title}</IonLabel>
            {defaultDate && (
                <>
                    <IonDatetimeButton datetime={`date-picker-${id}`} disabled={disabled} />
                    <IonPopover keepContentsMounted={true}>
                        <IonDatetime
                            id={`date-picker-${id}`}
                            presentation="date"
                            value={defaultDate.toISODate()}
                            onIonChange={(e) => onChange && onChange(DateTime.fromISO(e.detail.value as string))}
                        />
                    </IonPopover>
                </>
            )}
        </IonItem>
    );
};

export default DatePicker;
